var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "30px",
    viewBox: "0 0 39 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filtrado",
    transform: "translate(-733, -822)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    transform: "translate(447, 787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(286, 35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.45,16.5 C0.15,16.2 0,15.75 0,15.45 C0,15.15 0.15,14.7 0.45,14.4 L2.55,12.3 C3.15,11.7 4.05,11.7 4.65,12.3 L4.8,12.45 L13.05,21.3 C13.35,21.6 13.8,21.6 14.1,21.3 L34.2,0.45 L34.35,0.45 L34.35,0.45 C34.95,-0.15 35.85,-0.15 36.45,0.45 L38.55,2.55 C39.15,3.15 39.15,4.05 38.55,4.65 L38.55,4.65 L14.55,29.55 C14.25,29.85 13.95,30 13.5,30 C13.05,30 12.75,29.85 12.45,29.55 L0.75,16.95 L0.45,16.5 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5fe9331069915499b1ede29710dd88e9.svg";
export { ForwardRef as ReactComponent };